const newsItems = [
    {
        title: "Công nghệ máy trải vải hoàn toàn mới mang tính cách mạng",
        content: "Máy trải vải mới của OSHIMA có thể thay thế sáu mẫu truyền thống, nâng cao hiệu quả sản xuất.",
        image: "/files/images/newsItem_1.jpg",
        link: "https://baike.baidu.com/item/单针列缝机/4111900?fr=ge_ala"
    },
    {
        title: "Tiến bộ đáng kể trong máy trải vải tự động",
        content: "Máy trải vải hoàn toàn tự động có thể mở cuộn vải nặng tới 200 kilogram mà không có lực căng.",
        image: "/files/images/newsItem_2.jpg",
        link: "https://baike.baidu.com/item/单针列缝机/4111900?fr=ge_ala"
    },
    {
        title: "Ra mắt toàn cầu máy trải vải điện đầu tiên",
        content: "Công ty KWS đầu tư vào máy trải vải điện không phát thải đầu tiên trên thế giới, mở ra chương mới trong xây dựng đường.",
        image: "/files/images/newsItem_3.jpg",
        link: "https://baike.baidu.com/item/单针列缝机/4111900?fr=ge_ala"
    },
    {
        title: "Đổi mới môi trường trong ngành máy trải vải",
        content: "Thế hệ máy trải vải mới được trang bị điện tử mới nhất và phần mềm tùy chỉnh để đảm bảo hiệu suất tối ưu trong mọi thời điểm.",
        image: "/files/images/newsItem_4.jpg",
        link: "https://baike.baidu.com/item/单针列缝机/4111900?fr=ge_ala"
    },
    {
        title: "Mở rộng ứng dụng công nghệ trải vải tự động",
        content: "Máy trải vải tự động hiện được sử dụng rộng rãi không chỉ cho vật liệu dệt kim mà còn cho vải nặng và các loại vải khác.",
        image: "/files/images/newsItem_5.jpg",
        link: "https://baike.baidu.com/item/单针列缝机/4111900?fr=ge_ala"
    },
    {
        title: "Tự động hóa và đơn giản hóa vận hành máy trải vải",
        content: "Máy trải vải hiện đại đơn giản hóa đáng kể quy trình xử lý vải từ giá đỡ đến bộ thu thông qua hệ thống xỏ vải tự động.",
        image: "/files/images/newsItem_6.jpg",
        link: "https://baike.baidu.com/item/单针列缝机/4111900?fr=ge_ala"
    },
    {
        title: "Máy trải vải có chức năng bộ nhớ vải",
        content: "Máy trải vải mới nhất có thể lưu dữ liệu cho 30 loại vải, đơn giản hóa quy trình vận hành và nâng cao hiệu quả công việc.",
        image: "/files/images/newsItem_7.jpg",
        link: "https://baike.baidu.com/item/单针列缝机/4111900?fr=ge_ala"
    },
    {
        title: "Phản hồi thị trường về máy trải vải tự động",
        content: "Do dễ vận hành và hiệu suất cao, máy trải vải tự động đã được thị trường đón nhận rộng rãi.",
        image: "/files/images/newsItem_8.jpg",
        link: "https://baike.baidu.com/item/单针列缝机/4111900?fr=ge_ala"
    },
    {
        title: "Máy trải vải mới thúc đẩy phát triển ngành dệt",
        content: "Thiết kế của máy trải vải mới đã mang đến cơ hội phát triển mới cho ngành dệt, đặc biệt trong việc cải thiện hiệu quả sản xuất.",
        image: "/files/images/newsItem_9.jpg",
        link: "https://baike.baidu.com/item/单针列缝机/4111900?fr=ge_ala"
    },
    {
        title: "Giải pháp trải vải thông minh thế hệ tiếp theo",
        content: "Thế hệ máy trải vải mới nhất tích hợp hệ thống điều khiển thông minh tiên tiến, có khả năng xử lý chính xác nhiều loại vải khác nhau.",
        image: "/files/images/newsItem_10.jpg",
        link: "https://baike.baidu.com/item/单针列缝机/4111900?fr=ge_ala"
    }
];

export default newsItems;
